var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRnf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo-color",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.94 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t\t\t    .cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#New_Gradient_Swatch_5);}.cls-4{fill:url(#New_Gradient_Swatch_5-2);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#New_Gradient_Swatch_5-3);}.cls-7{fill:url(#New_Gradient_Swatch_3-2);}.cls-8{fill:url(#New_Gradient_Swatch_6);}.cls-9{fill:url(#New_Gradient_Swatch_6-2);}.cls-10{fill:url(#New_Gradient_Swatch_5-4);}.cls-11{fill:url(#New_Gradient_Swatch_6-3);}.cls-12{fill:url(#New_Gradient_Swatch_3-3);}.cls-13{fill:url(#linear-gradient);}.cls-14{fill:url(#New_Gradient_Swatch_3-4);}.cls-15{fill:url(#New_Gradient_Swatch_3-5);}.cls-16{fill:url(#New_Gradient_Swatch_6-4);}.cls-17{fill:url(#New_Gradient_Swatch_5-5);}.cls-18{fill:url(#New_Gradient_Swatch_6-5);}.cls-19{fill:url(#New_Gradient_Swatch_3-6);}.cls-20{fill:url(#New_Gradient_Swatch_3-7);}.cls-21{fill:url(#New_Gradient_Swatch_2);}.cls-22{fill:url(#New_Gradient_Swatch_2-2);}.cls-23{fill:url(#linear-gradient-2);}.cls-24{fill:url(#linear-gradient-3);}.cls-25{fill:url(#New_Gradient_Swatch_2-3);}.cls-26{fill:url(#New_Gradient_Swatch_2-4);}.cls-27{fill:url(#New_Gradient_Swatch_2-5);}.cls-28{fill:url(#linear-gradient-4);}.cls-29{fill:url(#New_Gradient_Swatch_5-6);}.cls-30{fill:url(#New_Gradient_Swatch_6-6);}.cls-31{fill:url(#New_Gradient_Swatch_3-8);}.cls-32{fill:url(#New_Gradient_Swatch_3-9);}.cls-33{fill:url(#New_Gradient_Swatch_3-10);}.cls-34{fill:url(#New_Gradient_Swatch_3-11);}.cls-35{fill:url(#New_Gradient_Swatch_3-12);}.cls-36{fill:url(#New_Gradient_Swatch_3-13);}.cls-37{fill:#231f20;}\n\t\t\t\t    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.07,1.79h28V141.73H31.15v-104L7.72,43.08.38,13.3Zm91.85,133.29c.58.3,1.16.57,1.75.85L162,108.65c-.79-.07-1.58-.15-2.36-.26a37.41,37.41,0,1,1,42.5-42.55c.12.79.2,1.59.27,2.4L229.64,41c-.29-.61-.58-1.22-.88-1.81a71.37,71.37,0,1,0-95.84,95.93Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 553.54,
    y1: -961.03,
    x2: -732.15,
    y2: 1953.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#007ec6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 188.02,
    y1: -309.77,
    x2: -222.07,
    y2: 619.77,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 330.36,
    y1: -625.16,
    x2: -550.7,
    y2: 1371.91,
    gradientTransform: "translate(17.49 -37.14) rotate(18.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b57a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2e3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-3",
    x1: 216.36,
    y1: -274.32,
    x2: -193.73,
    y2: 655.22,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 255.3,
    y1: -540.25,
    x2: -654.99,
    y2: 1523.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6",
    x1: 232.44,
    y1: -192.37,
    x2: -177.65,
    y2: 737.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec0d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7218d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-2",
    x1: 249.09,
    y1: -230.11,
    x2: -161,
    y2: 699.43,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-4",
    x1: 254.94,
    y1: -257.3,
    x2: -155.15,
    y2: 672.24,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-3",
    x1: 227.3,
    y1: -194.64,
    x2: -182.79,
    y2: 734.9,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 243.95,
    y1: -232.38,
    x2: -166.14,
    y2: 697.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 368.68,
    y1: -302.23,
    x2: -41.41,
    y2: 627.32,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 396.59,
    y1: -616.58,
    x2: -281.63,
    y2: 920.71,
    gradientTransform: "translate(370.78 36.11) rotate(-135)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 790.84,
    y1: -1266.11,
    x2: -1190.29,
    y2: 3224.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-4",
    x1: 152.97,
    y1: 24.95,
    x2: -257.12,
    y2: 954.5,
    gradientTransform: "matrix(0.75, 0.66, -0.66, 0.75, 275.38, -136.38)",
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-5",
    x1: 367.98,
    y1: -555.62,
    x2: -461.76,
    y2: 1325.12,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-5",
    x1: 484.07,
    y1: -634.57,
    x2: -426.21,
    y2: 1428.75,
    gradientTransform: "translate(81.11 -46.01) rotate(70.75)",
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 421.58,
    y1: -792.11,
    x2: -662.08,
    y2: 1664.21,
    gradientTransform: "matrix(0.71, -0.71, 0.67, 0.67, 90.12, 161.91)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 187.46,
    y1: 73.2,
    x2: -222.63,
    y2: 1002.74,
    gradientTransform: "matrix(0.3, 0.95, -0.95, 0.3, 400.11, -48.33)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 216.83,
    y1: 87.97,
    x2: 226.48,
    y2: 79.31,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 221.87,
    y1: 101.69,
    x2: 238.09,
    y2: 87.14,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 235.76,
    y1: 99.43,
    x2: 228.38,
    y2: 64.7,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 216.68,
    y1: 77.15,
    x2: 219.18,
    y2: 101.69,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 241.59,
    y1: 75.73,
    x2: 170.97,
    y2: 108.18,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 236.01,
    y1: 63.6,
    x2: 165.4,
    y2: 96.05,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 236.44,
    y1: 64.53,
    x2: 165.83,
    y2: 96.97,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 192.93,
    y1: 108.54,
    x2: 185.55,
    y2: 73.8,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-6",
    x1: 277.25,
    y1: 32.94,
    x2: 143.31,
    y2: 94.49,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-6",
    x1: 175.66,
    y1: 112.21,
    x2: 168.28,
    y2: 77.48,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 214.87,
    y1: 61.24,
    x2: 191.68,
    y2: 113.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 216.43,
    y1: 52.14,
    x2: 172.49,
    y2: 151.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 204.52,
    y1: 58.07,
    x2: 163.17,
    y2: 151.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 182.6,
    y1: 53.66,
    x2: 131.82,
    y2: 168.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 193.91,
    y1: 53.45,
    x2: 151.97,
    y2: 148.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 179.83,
    y1: 55.94,
    x2: 152.1,
    y2: 118.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -45,
    y: -65.51,
    width: 298.96,
    height: 244.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.58-.51a55,55,0,0,0-38.06,50A55,55,0,0,0,59.58-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.94-15.86A118.05,118.05,0,0,0-24.84,59.91,118.08,118.08,0,0,0,86.94-15.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.4,106.73a54.92,54.92,0,0,0,18.4-3.16A53.64,53.64,0,0,1,97,95.16a55,55,0,0,0-74.5-32.5A55,55,0,0,0,76.4,106.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6,166.5a121.91,121.91,0,0,0,40.84-7,119.51,119.51,0,0,1,5-18.67A122,122,0,0,0-63.7,58a121.56,121.56,0,0,0-49.87,10.66A122,122,0,0,0,6,166.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.87,101.93c-1.33.59-2.69,1.15-4.07,1.64a54.65,54.65,0,0,0,2,27.58A54.67,54.67,0,0,0,100,112.8,55.58,55.58,0,0,0,98.87,101.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.87,101.93c-1.33.59-2.69,1.15-4.07,1.64a54.65,54.65,0,0,0,2,27.58A54.67,54.67,0,0,0,100,112.8,55.58,55.58,0,0,0,98.87,101.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M94.8,103.57c1.38-.49,2.74-1,4.07-1.64A56.2,56.2,0,0,0,97,95.16,53.64,53.64,0,0,0,94.8,103.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M94.8,103.57c1.38-.49,2.74-1,4.07-1.64A56.2,56.2,0,0,0,97,95.16,53.64,53.64,0,0,0,94.8,103.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M94.8,103.57c1.38-.49,2.74-1,4.07-1.64A56.2,56.2,0,0,0,97,95.16,53.64,53.64,0,0,0,94.8,103.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 225.44,
    cy: 22.44,
    r: 54.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M159.24,43.53a37.84,37.84,0,0,1,12.69-2.18,38.36,38.36,0,0,1,5,.34,37.39,37.39,0,0,1,7.27,1.72A84.05,84.05,0,0,0,162.74-38.8a83.83,83.83,0,0,0-23.35-16.5,83.39,83.39,0,0,1-11.53,6.69c-15.52,31.44-22.47,70.51,16,96.73,3.76,2.56,6.64,6.11,10.21,8.69a36.15,36.15,0,0,0,5.22-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M194.36,66.16A139.65,139.65,0,0,1,176.12,106,139.85,139.85,0,0,1,143.8,88.57a63.59,63.59,0,0,1-27.69,24.15,64,64,0,0,1,1.25,12.55,63.24,63.24,0,0,1-3.64,21.18,63.39,63.39,0,1,0,80.64-80.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M95.59,158.73A55,55,0,0,1,68.26,80.32,54.94,54.94,0,1,0,78.89,180.78a54.73,54.73,0,0,1,16.7-22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M138.14,30.84a55,55,0,0,0-61.24-20,55,55,0,0,1-38.06,50c0,.76-.06,1.51-.06,2.28A55.65,55.65,0,0,0,39.86,74a54.92,54.92,0,0,1,74.49,32.49,55.42,55.42,0,0,1,33.4-33.42,54.87,54.87,0,0,0-9.61-42.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M90.38,199.42a121.7,121.7,0,0,0,20.1,36.24,120.69,120.69,0,0,1,19.27-1.47A121.95,121.95,0,0,0,143.31,54.3,122,122,0,0,0,90.38,199.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M146.21,194.73a133.66,133.66,0,0,1,15.48,8.64C179,160.08,175,111,149.08,72.82,129.86,111.73,128.8,156.71,146.21,194.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M48.69,140.08A54.9,54.9,0,0,0,57.2,156.7a54.06,54.06,0,0,1,8.7-.37A55,55,0,0,0,86,95.55a54.54,54.54,0,0,0-11.28-20A55,55,0,0,0,48.69,140.08Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M226,87a4.22,4.22,0,0,0,1.59-.32,4.08,4.08,0,0,0,1-.65l-.4-.38a17.2,17.2,0,0,1-3.69-5.47,17.68,17.68,0,0,1-1.07-3.61h-.33v2c-4,.14-7.53,1.17-9.57,3.85a13.65,13.65,0,0,1,2.1.71A14.63,14.63,0,0,1,218.89,85a4.13,4.13,0,0,1,1.5-.29A4.18,4.18,0,0,1,222,85a4,4,0,0,1,1.13.72l0,0,.17.16a4,4,0,0,0,1.13.72A4.18,4.18,0,0,0,226,87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M235.59,90c-.05.13-.09.27-.15.39a4,4,0,0,1-.87,1.3,4.15,4.15,0,0,1-1.3.88,4.09,4.09,0,0,1-4.34-.74v0l-.14-.13a4.11,4.11,0,0,0-1.15-.74,4.11,4.11,0,0,0-3.18,0,3.59,3.59,0,0,0-.72.4,14.88,14.88,0,0,1,1.07,5.56,15.18,15.18,0,0,1-.59,4.18h4.9V99c5.72-.19,10.52-2.25,11.33-8.33A17.28,17.28,0,0,1,235.59,90Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M229.14,78.57v-2H223.5a17.68,17.68,0,0,0,1.07,3.61,17.2,17.2,0,0,0,3.69,5.47l.4.38.09-.07a1.29,1.29,0,0,0,.17-.16l.05,0a4.12,4.12,0,0,1,1.12-.72,4.11,4.11,0,0,1,3.18,0,4.15,4.15,0,0,1,1.3.88,4.05,4.05,0,0,1,1.19,2.88,4.3,4.3,0,0,1-.17,1.2,17.28,17.28,0,0,0,4.85.7,14.33,14.33,0,0,0,.13-1.91C240.57,81.21,235.43,78.78,229.14,78.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M223.73,91.3a4.7,4.7,0,0,0-.44.34l-.14.13v0a4.25,4.25,0,0,1-1.16.74,4.11,4.11,0,0,1-3.18,0,4.22,4.22,0,0,1-1.29-.88,4.15,4.15,0,0,1-.88-1.3,4,4,0,0,1-.32-1.59,4,4,0,0,1,.32-1.59A4.21,4.21,0,0,1,218.8,85l.09,0a14.63,14.63,0,0,0-3.19-1.84,13.65,13.65,0,0,0-2.1-.71,10.1,10.1,0,0,0-1.85,6.33c0,7.57,5.17,10,11.46,10.24V101h1a15.18,15.18,0,0,0,.59-4.18A14.88,14.88,0,0,0,223.73,91.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M204.83,85.44a17.2,17.2,0,0,1-3.64,5.4l-.36.34h.55v9.75h6.35V82.12a14.21,14.21,0,0,0-2,.43A17.68,17.68,0,0,1,204.83,85.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M194.68,91.18h1.45s0-.08.05-.13a14.84,14.84,0,0,1,3.19-4.73q.47-.45,1-.87h-6.45V76.63h-6.36v7a15.63,15.63,0,0,1,7.16,7.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M201.38,84.64l.79-.52.58-.34a13.06,13.06,0,0,1,1.36-.65,13.29,13.29,0,0,1,1.64-.58,17,17,0,0,0,.41-3.73,17.64,17.64,0,0,0-.14-2.19h-4.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M187.52,95.73v5.2h6.36V95.15a17.07,17.07,0,0,1-4.71.66A15,15,0,0,1,187.52,95.73Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M177.23,77a15.9,15.9,0,0,1-2.91,1.62,16.14,16.14,0,0,1-6.14,1.24,15.8,15.8,0,0,1-4.15-.56v3.37a5,5,0,0,0,1,.59,4.63,4.63,0,0,0,3.58,0,4.43,4.43,0,0,0,1.27-.81l.2-.18s0,0,0,0a4.4,4.4,0,0,1,1.27-.8,4.17,4.17,0,0,1,.91-.28,4.31,4.31,0,0,1,.88-.09,4.44,4.44,0,0,1,1.79.37,4.52,4.52,0,0,1,1.46,1,15.82,15.82,0,0,1,3.86-.48,15.44,15.44,0,0,1,2.47.2A8.1,8.1,0,0,0,177.23,77Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M170.24,94.72h4.48A8.63,8.63,0,0,0,180,93.1a17,17,0,0,1-2.81-2.26,16.64,16.64,0,0,1-1.3-1.47,4,4,0,0,1-.86.48,4.51,4.51,0,0,1-3.58,0A4.35,4.35,0,0,1,170.1,89h0a1.1,1.1,0,0,0-.16-.15,4.38,4.38,0,0,0-1.31-.84,4.26,4.26,0,0,0-.63-.22,15.69,15.69,0,0,0-3.44,9.82,16.29,16.29,0,0,0,.35,3.31h5.34Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M206,76.63a17.64,17.64,0,0,1,.14,2.19,17,17,0,0,1-.41,3.73,14.21,14.21,0,0,1,2-.43V76.63Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M202.75,83.78l-.58.34-.79.52v.81h-1q-.5.42-1,.87a14.84,14.84,0,0,0-3.19,4.73s0,.09-.05.13h4.7l.36-.34a17.2,17.2,0,0,0,3.64-5.4,17.68,17.68,0,0,0,.92-2.89,13.29,13.29,0,0,0-1.64.58A13.06,13.06,0,0,0,202.75,83.78Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M187.52,83.62V95.73a15,15,0,0,0,1.65.08,17.07,17.07,0,0,0,4.71-.66v-4h.8a15.63,15.63,0,0,0-7.16-7.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M165,88a4.45,4.45,0,0,0-1,.59v12.32h.87a16.29,16.29,0,0,1-.35-3.31A15.69,15.69,0,0,1,168,87.8a4.91,4.91,0,0,0-1.16-.14A4.61,4.61,0,0,0,165,88Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M180.31,81.87a15.82,15.82,0,0,0-3.86.48h0a4.73,4.73,0,0,1,1,1.47,4.51,4.51,0,0,1,0,3.58,4.62,4.62,0,0,1-1,1.47,5.79,5.79,0,0,1-.61.5,16.64,16.64,0,0,0,1.3,1.47A17,17,0,0,0,180,93.1c3.33-2.45,4.27-7.25,2.82-11A15.44,15.44,0,0,0,180.31,81.87Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M174.72,76.63H164v2.62a15.8,15.8,0,0,0,4.15.56,16.14,16.14,0,0,0,6.14-1.24A15.9,15.9,0,0,0,177.23,77,9.91,9.91,0,0,0,174.72,76.63Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M179.14,112.07a2.13,2.13,0,0,1-.11.7,1.81,1.81,0,0,1-.36.65,2.06,2.06,0,0,1-.66.47,2.33,2.33,0,0,1-1,.18h-1.17v2.48h-1.4v-6.46h2.45a2.33,2.33,0,0,1,1.66.53A1.92,1.92,0,0,1,179.14,112.07Zm-3.27-1v2.05h.91a1.49,1.49,0,0,0,.36-.05.85.85,0,0,0,.31-.17,1.11,1.11,0,0,0,.21-.32,1.34,1.34,0,0,0,.08-.48,1,1,0,0,0-.29-.79,1.08,1.08,0,0,0-.72-.24Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M184.28,114.24a3.39,3.39,0,0,1-.12.91,2,2,0,0,1-.41.77,1.92,1.92,0,0,1-.73.53,2.8,2.8,0,0,1-1.11.19,2.63,2.63,0,0,1-1.07-.19,1.75,1.75,0,0,1-.72-.51,2,2,0,0,1-.39-.76,3.49,3.49,0,0,1-.11-.93,3.12,3.12,0,0,1,.13-.93,1.94,1.94,0,0,1,.41-.76,2,2,0,0,1,.73-.53,3,3,0,0,1,2.17,0,1.9,1.9,0,0,1,.71.52,2.08,2.08,0,0,1,.39.77A3.46,3.46,0,0,1,184.28,114.24Zm-1.39,0a3.27,3.27,0,0,0,0-.54,1.71,1.71,0,0,0-.13-.47.83.83,0,0,0-.28-.33.77.77,0,0,0-.47-.13.82.82,0,0,0-.48.13,1,1,0,0,0-.3.33,1.73,1.73,0,0,0-.15.47,3.29,3.29,0,0,0,0,.54,5.1,5.1,0,0,0,0,.57,1.4,1.4,0,0,0,.15.45.86.86,0,0,0,.29.31,1,1,0,0,0,.5.11.86.86,0,0,0,.47-.12.77.77,0,0,0,.28-.31,1.62,1.62,0,0,0,.13-.47A3.19,3.19,0,0,0,182.89,114.25Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M186.35,114.24a1.8,1.8,0,0,0,.24,1,1,1,0,0,0,.87.36,2.59,2.59,0,0,0,.63-.07,5.1,5.1,0,0,0,.61-.17l.25.89a3.41,3.41,0,0,1-.8.28,4.73,4.73,0,0,1-.93.09,2.87,2.87,0,0,1-1.1-.18,1.75,1.75,0,0,1-.68-.5,1.92,1.92,0,0,1-.35-.75,4.28,4.28,0,0,1-.1-.9,3.56,3.56,0,0,1,.1-.84,2.06,2.06,0,0,1,.34-.79,2,2,0,0,1,.7-.6,2.48,2.48,0,0,1,1.14-.23,5.58,5.58,0,0,1,.67,0,3.72,3.72,0,0,1,.77.18c0,.16-.07.31-.1.46s-.07.32-.11.48a3.14,3.14,0,0,0-.55-.11l-.45,0a1,1,0,0,0-.86.36A1.6,1.6,0,0,0,186.35,114.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M190.78,114.24a1.8,1.8,0,0,0,.24,1,1,1,0,0,0,.87.36,2.56,2.56,0,0,0,.62-.07,4.63,4.63,0,0,0,.61-.17l.26.89a3.34,3.34,0,0,1-.81.28,4.73,4.73,0,0,1-.93.09,2.82,2.82,0,0,1-1.09-.18,1.68,1.68,0,0,1-.68-.5,1.79,1.79,0,0,1-.35-.75,3.71,3.71,0,0,1-.1-.9,4.14,4.14,0,0,1,.09-.84,2.08,2.08,0,0,1,.35-.79,2,2,0,0,1,.69-.6,2.56,2.56,0,0,1,1.15-.23,5.73,5.73,0,0,1,.67,0,3.63,3.63,0,0,1,.76.18c0,.16-.06.31-.1.46s-.07.32-.1.48a3.33,3.33,0,0,0-.55-.11l-.46,0a1,1,0,0,0-.85.36A1.54,1.54,0,0,0,190.78,114.24Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M197.24,116.55v-2.79h-.05l-.66,1-1.19,1.76h-1.27v-4.61h1.34v2.79h.05l.51-.8,1.33-2h1.28v4.61Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M202.78,116.55v-2.79h0l-.67,1-1.18,1.76h-1.28v-4.61H201v2.79H201l.52-.8,1.32-2h1.29v4.61Zm-.92-5.13a1.39,1.39,0,0,1-.53-.1,1.83,1.83,0,0,1-.46-.28,2.94,2.94,0,0,1-.4-.39,3.19,3.19,0,0,1-.35-.47l.56-.42a2.2,2.2,0,0,0,.63.6,1.18,1.18,0,0,0,.58.2h.21a1,1,0,0,0,.3-.08,2.77,2.77,0,0,0,.39-.22,3.83,3.83,0,0,0,.53-.42l.4.36a3.17,3.17,0,0,1-.46.58,2.28,2.28,0,0,1-.48.38,1.75,1.75,0,0,1-.47.21A1.86,1.86,0,0,1,201.86,111.42Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M206.36,114.24a1.8,1.8,0,0,0,.24,1,1,1,0,0,0,.87.36,2.59,2.59,0,0,0,.63-.07,5.1,5.1,0,0,0,.61-.17l.25.89a3.41,3.41,0,0,1-.8.28,4.91,4.91,0,0,1-.94.09,2.82,2.82,0,0,1-1.09-.18,1.75,1.75,0,0,1-.68-.5,1.79,1.79,0,0,1-.35-.75,3.71,3.71,0,0,1-.1-.9,4.14,4.14,0,0,1,.09-.84,2.25,2.25,0,0,1,.35-.79,2,2,0,0,1,.69-.6,2.56,2.56,0,0,1,1.15-.23,5.73,5.73,0,0,1,.67,0,3.88,3.88,0,0,1,.77.18c0,.16-.07.31-.1.46s-.07.32-.11.48a3.14,3.14,0,0,0-.55-.11l-.46,0a1,1,0,0,0-.85.36A1.6,1.6,0,0,0,206.36,114.24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M209.65,116.55v-4.61H211v1.75h.63a.87.87,0,0,0,.51-.14.77.77,0,0,0,.3-.47c.06-.19.11-.38.17-.57l.18-.56H214l-.18.64c-.06.22-.12.43-.19.65a1.22,1.22,0,0,1-.25.51,1,1,0,0,1-.44.33v0a1.09,1.09,0,0,1,.55.32,1.42,1.42,0,0,1,.27.5l.5,1.63h-1.32c-.06-.24-.13-.47-.2-.7s-.15-.46-.23-.7a.74.74,0,0,0-.36-.51,1.12,1.12,0,0,0-.53-.12H211v2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M218.14,116.55v-2.79h0l-.67,1-1.18,1.76H215v-4.61h1.34v2.79h0l.52-.8,1.32-2h1.29v4.61Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M223.68,116.55v-2.79h-.05l-.66,1-1.18,1.76h-1.28v-4.61h1.34v2.79h.05l.51-.8,1.33-2H225v4.61Zm-.92-5.13a1.35,1.35,0,0,1-.53-.1,1.83,1.83,0,0,1-.46-.28,3,3,0,0,1-.41-.39,4,4,0,0,1-.34-.47l.56-.42a2.2,2.2,0,0,0,.63.6,1.18,1.18,0,0,0,.58.2H223a1,1,0,0,0,.3-.08,2.77,2.77,0,0,0,.39-.22,3.83,3.83,0,0,0,.53-.42l.4.36a3.67,3.67,0,0,1-.46.58,2.28,2.28,0,0,1-.48.38,1.67,1.67,0,0,1-.48.21A1.72,1.72,0,0,1,222.76,111.42Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M170.52,127.53v-2h-1.74v2h-1.34v-4.61h1.34v1.74h1.74v-1.74h1.35v4.61Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M176.9,126.64h.6l.06.75a2.89,2.89,0,0,1-.52.17,3.05,3.05,0,0,1-.6.06,1.13,1.13,0,0,1-.51-.1.52.52,0,0,1-.23-.45l0,0a2.63,2.63,0,0,1-.49.33,3.78,3.78,0,0,1-.46.17,2,2,0,0,1-.38.06h-.27a1.64,1.64,0,0,1-.71-.13,1.38,1.38,0,0,1-.43-.34,1.14,1.14,0,0,1-.22-.44,1.71,1.71,0,0,1-.06-.43,1.32,1.32,0,0,1,.13-.62,1.13,1.13,0,0,1,.36-.45,1.56,1.56,0,0,1,.54-.29,2.35,2.35,0,0,1,.67-.12l.63,0,.63,0v-.11a1,1,0,0,0-.17-.6.89.89,0,0,0-.68-.2,4,4,0,0,0-.74.07,4.62,4.62,0,0,0-.73.17c0-.15-.06-.29-.1-.43s-.08-.27-.11-.41a4.45,4.45,0,0,1,.95-.28,5.56,5.56,0,0,1,1.05-.1,3,3,0,0,1,.75.08,1.67,1.67,0,0,1,.57.27,1.15,1.15,0,0,1,.36.5,2,2,0,0,1,.13.75Zm-2.21-1.1c-.43,0-.65.25-.65.63a.6.6,0,0,0,.15.44.66.66,0,0,0,.48.15,1.23,1.23,0,0,0,.47-.11,1.75,1.75,0,0,0,.48-.3v-.89Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M180,126.68l.26-1c.06-.19.12-.4.19-.64s.14-.48.21-.74.14-.5.22-.74.13-.45.19-.64h1.36l-1.85,5.48a1.81,1.81,0,0,1-.59.89,1.56,1.56,0,0,1-.94.27l-.49,0a6.2,6.2,0,0,1-.71-.14l.19-.89.39.06.27,0a.82.82,0,0,0,.49-.12.87.87,0,0,0,.27-.45.35.35,0,0,1,0-.1l.06-.19.06-.2a.65.65,0,0,0,0-.1h-.6l-1.43-4.5H179l.18.62c.06.24.13.5.2.75l.21.77.18.65a5.23,5.23,0,0,1,.12.54l.09.42Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M186,127.53v-1.81a3,3,0,0,1-.7.22,5,5,0,0,1-.73.07,1.94,1.94,0,0,1-.72-.12,1,1,0,0,1-.46-.31,1.18,1.18,0,0,1-.26-.48,2.09,2.09,0,0,1-.08-.63v-1.55h1.34v1.3a1.07,1.07,0,0,0,.13.57c.08.14.25.21.52.21a2.9,2.9,0,0,0,.48,0,1.69,1.69,0,0,0,.48-.15v-1.9h1.35v4.62Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M191.41,127.53v-2h-1.74v2h-1.34v-4.61h1.34v1.74h1.74v-1.74h1.34v4.61Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M195.12,122.92v1.54h1.4a2,2,0,0,1,.66.11,1.4,1.4,0,0,1,.53.31,1.42,1.42,0,0,1,.49,1.11,1.61,1.61,0,0,1-.12.63,1.44,1.44,0,0,1-.34.49,1.41,1.41,0,0,1-.5.31,1.81,1.81,0,0,1-.63.11h-2.83v-4.61Zm0,2.34v1.4h1.08a.66.66,0,0,0,.51-.19.71.71,0,0,0,.18-.5.69.69,0,0,0-.21-.52.73.73,0,0,0-.53-.19Zm3.53,2.27v-4.61H200v4.61Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M204.19,127.53v-2.79h-.05l-.67,1-1.18,1.76H201v-4.61h1.34v2.8h0l.51-.81,1.32-2h1.29v4.61Zm-.92-5.13a1.32,1.32,0,0,1-.53-.1,1.89,1.89,0,0,1-.47-.28,2.92,2.92,0,0,1-.4-.39c-.12-.15-.24-.3-.35-.46l.57-.43a2.31,2.31,0,0,0,.62.6,1.12,1.12,0,0,0,.59.2h.21a.75.75,0,0,0,.29-.08,3.15,3.15,0,0,0,.4-.21,4,4,0,0,0,.52-.43l.41.36a3.29,3.29,0,0,1-.47.59,3.19,3.19,0,0,1-.48.38,1.9,1.9,0,0,1-.47.2A1.78,1.78,0,0,1,203.27,122.4Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M211.56,127.6a3.54,3.54,0,0,1-1.24-.24,2.08,2.08,0,0,1-.78-.54,1.91,1.91,0,0,1-.4-.74,3.56,3.56,0,0,1-.11-.86,2.67,2.67,0,0,1,.16-1,1.82,1.82,0,0,1,.46-.74,2.45,2.45,0,0,1,.79-.51,3.39,3.39,0,0,1,1.12-.2v-2h1.31v2A3.48,3.48,0,0,1,214,123a2.07,2.07,0,0,1,.79.48,1.79,1.79,0,0,1,.46.73,2.75,2.75,0,0,1,.15.93,3,3,0,0,1-.14,1,1.89,1.89,0,0,1-.44.75,2.18,2.18,0,0,1-.79.52,3.52,3.52,0,0,1-1.17.23v1.88h-1.31Zm-1.26-2.38a1.84,1.84,0,0,0,.28,1.08,1.18,1.18,0,0,0,1,.43v-3a1.76,1.76,0,0,0-.62.16,1.12,1.12,0,0,0-.38.33,1.26,1.26,0,0,0-.21.47A3.21,3.21,0,0,0,210.3,125.22Zm2.56,1.51a1.2,1.2,0,0,0,1-.45,1.73,1.73,0,0,0,.3-1.06,2.47,2.47,0,0,0-.06-.56,1.18,1.18,0,0,0-.2-.47,1,1,0,0,0-.38-.34,1.55,1.55,0,0,0-.63-.14Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M220.77,125.22a3.39,3.39,0,0,1-.12.91,1.93,1.93,0,0,1-1.13,1.3,2.8,2.8,0,0,1-1.11.19,2.64,2.64,0,0,1-1.08-.19,1.78,1.78,0,0,1-.71-.51,2,2,0,0,1-.39-.76,3.48,3.48,0,0,1-.12-.93,3.17,3.17,0,0,1,.13-.93,2.23,2.23,0,0,1,.41-.76,2.12,2.12,0,0,1,.73-.53,2.73,2.73,0,0,1,1.09-.19,2.64,2.64,0,0,1,1.08.19,1.86,1.86,0,0,1,.72.52,2.16,2.16,0,0,1,.39.77A3.51,3.51,0,0,1,220.77,125.22Zm-1.38,0a4.9,4.9,0,0,0,0-.54,1.72,1.72,0,0,0-.14-.47,1,1,0,0,0-.27-.33.84.84,0,0,0-.47-.13.85.85,0,0,0-.48.13.94.94,0,0,0-.3.33,1.45,1.45,0,0,0-.16.47,3.27,3.27,0,0,0,0,.54,3.32,3.32,0,0,0,0,.57,1.24,1.24,0,0,0,.14.46.79.79,0,0,0,.3.3.91.91,0,0,0,.5.11.92.92,0,0,0,.46-.11.79.79,0,0,0,.28-.32,1.62,1.62,0,0,0,.14-.47A4.56,4.56,0,0,0,219.39,125.23Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M224.73,127.53v-2H223v2h-1.34v-4.61H223v1.74h1.75v-1.74h1.34v4.61Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M231.59,126.63l.48,0v2.28h-1v-1.4h-3.33v1.38h-1v-2.26l.45,0a1.64,1.64,0,0,0,.31-.41,2.73,2.73,0,0,0,.19-.59,6.76,6.76,0,0,0,.12-.76c0-.29.05-.61.08-1l.07-1h3.63Zm-2.48-2.8,0,.34a12.31,12.31,0,0,1-.15,1.53,2.09,2.09,0,0,1-.37.93h1.68v-2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRnf);
export default __webpack_public_path__ + "static/media/rnf.f50f748520d1fbd7fa8ff241502694d6.svg";
export { ForwardRef as ReactComponent };